<!--
ProgressBar Component — wraps PrimeVue ProgressBar for determinate progress.

Use for measurable progress (uploads, batch operations, conciliation totals).
For top-of-page navigation/loading bars, prefer <LoadingProgressBar>.
For KPI-style filled bars with target values, prefer <KpiProgressBar>.
-->

<template>
  <PrimeProgressBar v-bind="$attrs">
    <slot />
  </PrimeProgressBar>
</template>

<script setup lang="ts">
import PrimeProgressBar from 'primevue/progressbar';

defineOptions({ name: 'ProgressBar', inheritAttrs: false });
</script>
